import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import ProductCard from "../ProductList/ProductCard";
import toast from "react-hot-toast";
import { cartContext } from "../../Context/CartContext";

const RelatedProducts = ({ categoryId, currentProductId, productName }) => {
  const navigate = useNavigate();
  let { setnumOfCartItems } = useContext(cartContext);
  const [relatedProducts, setRelatedProducts] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [loadingProducts, setLoadingProducts] = useState({});

  const handleAddToCart = async (productId, quantity) => {
    if (!localStorage.getItem("Auth")) {
      toast.error("Please login first");
      navigate("/login");
      return;
    }

    setLoadingProducts((prev) => ({ ...prev, [productId]: true }));
    try {
      let response = await axios.post(
        "https://api.elza2.store/api/v1/cart",
        { product: productId, quantity },
        { headers: { Authorization: localStorage.getItem("Auth") } }
      );
      toast.success("Added to cart");
      setnumOfCartItems(response.data.numOfCartItems);
    } catch (error) {
      toast.error("Failed to add to cart");
    } finally {
      setLoadingProducts((prev) => ({ ...prev, [productId]: false }));
    }
  };

  useEffect(() => {
    const fetchRelatedProducts = async () => {
      if (!categoryId) return;

      setIsLoading(true);
      try {
        const { data } = await axios.get(
          `https://api.elza2.store/api/v1/products/related/${categoryId._id}?name=${productName}&limit=10&page=1`
        );

        // Exclude the current product from the related products
        const filteredProducts = data.products.filter(
          (product) => product._id !== currentProductId
        );

        setRelatedProducts(filteredProducts);
      } catch (error) {
        console.error("Error fetching related products:", error);
      }
      setIsLoading(false);
    };

    fetchRelatedProducts();
  }, [categoryId, currentProductId, productName]);

  if (isLoading) {
    return (
      <div className="flex items-center justify-center py-12">
        <div className="animate-pulse w-12 h-12 bg-gray-300 rounded-full"></div>
      </div>
    );
  }

  if (relatedProducts.length === 0) return null;

  return (
    <section className="container mx-auto px-4 py-12">
      <h2 className="text-3xl font-bold text-gray-900 mb-8 text-center">
        You Might Also Like
      </h2>
      <div className="relative group">
        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-4">
          {relatedProducts.map((product) => (
            <ProductCard
              key={product._id}
              product={product}
              onAddToCart={handleAddToCart}
              loading={loadingProducts[product._id]}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default RelatedProducts;
